import React from 'react'
import WithdrawConfirmationPopup from '@bet25/ui/WithdrawConfirmationPopup'
import { ModalService } from 'services/ModalService'

const ConfirmPopup = ({ data }) => {
    const closeModal = () => {
        ModalService.closeModal('WITHDRAW_CONFIRM_POPUP')
    }

    const handleAccept = () => {
        if (data.resetBankAccInfo) {
            data.resetBankAccInfo()
            closeModal()
        }
    }

    return (
        <WithdrawConfirmationPopup
            currentTheme={'dark'}
            onCloseModal={closeModal}
            onClickAccept={handleAccept}
        />
    )
}

export default ConfirmPopup
